import type { LayerConfig } from './types';
import { LayerType } from './types';
import { getDefaultConfig } from '.';
import { MVTLayer } from '@deck.gl/geo-layers';
import type { Feature } from 'geojson';

export const CRITICAL_TREES_ZOOM_LEVEL = 15;
const getColor = (d: Feature): [number, number, number, number] => {
  if (d.properties?.max === 1000) {
    return [220, 27, 26, 255];
  }
  return [170, 170, 170, 112];
};

const getLine = (d: Feature) => {
  if (d.properties?.max === 1000) {
    return 2;
  }
  return 1;
};

export const getCriticalTreesLayer = (
  datasetId: string,
  config: LayerConfig,
  user: string = '',
  minZoom = 13,
  maxZoom = 24
) => {
  const id = LayerType[LayerType.critical_trees];
  return new MVTLayer({
    ...getDefaultConfig(user ? id : datasetId, user),
    id,
    ...config,
    minZoom,
    maxZoom,
    pickable: false,
    autoHighlight: false,
    lineWidthUnits: 'pixels',
    lineWidthMinPixels: 1,
    lineWidthMaxPixels: 4,
    getLineWidth: getLine,
    getLineColor: getColor,
    stroked: true,
    filled: false,
  });
};

export const CRITICAL_TREES_OVERVIEW_COLOURS: [number, number, number][] = [
  [227, 51, 51],
  [241, 127, 127],
  [248, 178, 178],
  [208, 248, 251],
];
